/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import TagManager from 'react-gtm-module'
import { GOOGLE_TAG_MANAGER, GOOGLE_TAG_MANAGER_AUTH, GOOGLE_TAG_MANAGER_PREVIEW } from '../Config'

const enhance = compose(
  connect(({ firebase: { auth, profile } }) => ({
    auth,
    profile,
  })),
)

const GoogleTagManager = ({ auth, profile }) => {
  let initialized = false
  useEffect(() => {
    let tagManagerArgs = {}
    if (GOOGLE_TAG_MANAGER && GOOGLE_TAG_MANAGER.gtmId) {
      // New GTM Config Format
      tagManagerArgs = GOOGLE_TAG_MANAGER
    } else {
      // Old Format
      tagManagerArgs.gtmId = GOOGLE_TAG_MANAGER
      if (GOOGLE_TAG_MANAGER_AUTH) {
        tagManagerArgs.auth = GOOGLE_TAG_MANAGER_AUTH
      }
      if (GOOGLE_TAG_MANAGER_PREVIEW) {
        tagManagerArgs.preview = GOOGLE_TAG_MANAGER_PREVIEW
      }
    }

    if (!GOOGLE_TAG_MANAGER) {
      initialized = true
    } else if (auth.isLoaded && profile.isLoaded) {
      if (auth.isEmpty) {
        TagManager.initialize(tagManagerArgs)
      } else {
        tagManagerArgs.dataLayer = {
          email: auth.email,
        }
        TagManager.initialize(tagManagerArgs)
      }
      initialized = true
    } else {
      // Wait until auth is loaded
    }
  }, [auth, profile])

  useEffect(() => {
    let tagManagerArgs = {}
    if (GOOGLE_TAG_MANAGER && GOOGLE_TAG_MANAGER.gtmId) {
      // New GTM Config Format
      tagManagerArgs = GOOGLE_TAG_MANAGER
    } else {
      // Old Format
      tagManagerArgs.gtmId = GOOGLE_TAG_MANAGER
      if (GOOGLE_TAG_MANAGER_AUTH) {
        tagManagerArgs.auth = GOOGLE_TAG_MANAGER_AUTH
      }
      if (GOOGLE_TAG_MANAGER_PREVIEW) {
        tagManagerArgs.preview = GOOGLE_TAG_MANAGER_PREVIEW
      }
    }

    if (!initialized && auth.isLoaded && profile.isLoaded) {
      if (auth.isEmpty) {
        TagManager.initialize(tagManagerArgs)
      } else {
        tagManagerArgs.dataLayer = {
          email: auth.email,
        }
        TagManager.initialize(tagManagerArgs)
      }
      initialized = true
    }
  }, [auth, profile])

  return null
}

export default enhance(GoogleTagManager)
